import { useTranslation } from "react-i18next";
import { useGeoPrompt } from "../hooks/useGeoPrompt";

interface WelcomeStateProps {
  onSend: (content: string) => void;
  onDrawToggle: () => void;
}

export function WelcomeState({ onSend }: WelcomeStateProps) {
  const { t } = useTranslation();
  const { status, trigger } = useGeoPrompt();
  const isLocating = status === "locating";

  return (
    <div className="flex flex-col items-center justify-center h-full gap-6 px-6 animate-cx-fade-in">
      <div className="text-center">
        <h1 className="cx-welcome-heading text-[24px] font-medium">
          Ortvis
        </h1>
        <p className="cx-welcome-subtitle mt-1.5 text-[14px]">
          {t("chat.welcome")}
        </p>
      </div>

      <div className="flex flex-col gap-2 w-full max-w-md">
        {/* Geo-prompt chip */}
        <button
          className="cx-suggestion-chip"
          onClick={() => trigger(onSend)}
          disabled={isLocating}
        >
          {isLocating ? (
            <span className="flex items-center gap-2">
              <svg
                className="animate-cx-spin"
                width="14"
                height="14"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
              >
                <path d="M21 12a9 9 0 1 1-6.219-8.56" />
              </svg>
              {t("chat.geoLocating")}
            </span>
          ) : (
            <>📍 {t("chat.geoPrompt")}</>
          )}
        </button>

      </div>

      <p className="cx-welcome-hint text-[12px] mt-2">
        {t("shortcuts.hint")}
      </p>
    </div>
  );
}
